import ismail from "../../assets/authors/ismail.jpg";
import muntasir from "../../assets/authors/muntasir.jpg";
import ranok from "../../assets/authors/ranok.jpg";
import idGen from "./../../lib/IdGen";

const initialState = [
  {
    id: idGen(15),
    title: "Learn HTML ",
    category: "Web Development",
    author: "Ranok Raihan",
    authorAvatar: ranok,
    thumbnail: "https://images.unsplash.com/photo-1527427337751-fdca2f128ce5?w=640&q=80",
    date: "2020-05-06",
    readTime: 3,
  },
  {
    id: idGen(15),
    title: "Micro Chip evolution ",
    category: "Technology",
    author: "Muntasir Tonoy",
    authorAvatar: muntasir,
    thumbnail: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=640&q=80",
    date: "2021-08-06",
    readTime: 6,
  },
  {
    id: idGen(15),
    title: "Learn CSS advance topic ",
    category: "Web Development",
    author: "Ismail Hossain",
    authorAvatar: ismail,
    thumbnail: "https://images.unsplash.com/photo-1507721999472-8ed4421c4af2?w=640&q=80",
    date: "2019-09-17",
    readTime: 2,
  },
  {
    id: idGen(15),
    title: " Fashion Reflects Lifestyle",
    category: "Life Style",
    author: "Ranok Raihan",
    authorAvatar: ranok,
    thumbnail: "https://images.unsplash.com/photo-1502301197179-65228ab57f78?w=640&q=80",
    date: "2020-08-23",
    readTime: 8,
  },
  {
    id: idGen(15),
    title: "Learn JavaScript core concepts",
    category: "Web Development",
    author: "Muntasir Tonoy",
    authorAvatar: muntasir,
    thumbnail: "https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?w=640&q=80",
    date: "2021-11-14",
    readTime: 9,
  },
  {
    id: idGen(15),
    title: "The benifits of fresh Morning Air",
    category: "Life Style",
    author: "Ismail Hossain",
    authorAvatar: ismail,
    thumbnail: "https://images.unsplash.com/photo-1566501248434-6d513596c485?w=640&q=80",
    date: "2018-07-16",
    readTime: 9,
  },
  {
    id: idGen(15),
    title: "Future is here",
    category: "Technology",
    author: "Ranok Raihan",
    authorAvatar: ranok,
    thumbnail: "https://images.unsplash.com/photo-1504890001746-a9a68eda46e2?w=640&q=80",
    date: "2022-08-27",
    readTime: 3,
  },
  {
    id: idGen(15),
    title: "Roadmap of becoming a MERN stack Developer",
    category: "Web Development",
    author: "Ranok Raihan",
    authorAvatar: ranok,
    thumbnail: "https://images.unsplash.com/photo-1573496773905-f5b17e717f05?w=640&q=80",
    date: "2022-07-04",
    readTime: 6,
  },
  {
    id: idGen(15),
    title: "Way of a better life",
    category: "Life Style",
    author: "Muntasir Tonoy",
    authorAvatar: muntasir,
    thumbnail: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=640&q=80",
    date: "2020-03-25",
    readTime: 3,
  },
];

export default initialState;
